<template>
  <div>
    <div v-if="$store.state.ui.os.isPC" class="container">
      <div class="pointer" v-for="(item, index) in inprint" :key="index" style="text-align: center;width: 7vh;min-height: 7vh;margin-bottom: 15px;">
        <template v-if="selected === item.type">
          <el-image v-if="item.image" @click="select(item)" style="width: 7vh" :src="require(`@/assets/render/${item.image}_selected.png`)"></el-image>
          <div style="color:#e3000b;" @click="select(item)">{{ uperFirst(item.type) }}</div>
        </template>
        <template v-else>
          <el-image v-if="item.image" @click="select(item)" style="width: 7vh" :src="require(`@/assets/render/${item.image}.png`)"></el-image>
          <div style="color:black" @click="select(item)">{{ uperFirst(item.type) }}</div>
        </template>
      </div>
    </div>
    <div v-else class="containerPhone">
      <div class="pointer" v-for="(item, index) in inprint" :key="index" style="text-align: center;min-height: 7vh;;margin-bottom: 10px;">
        <template v-if="selected === item.type">
          <el-image v-if="item.image" @click="select(item)" style="width: 7vh;" :src="require(`@/assets/render/${item.image}_selected.png`)"></el-image>
          <div style="color:#e3000b" @click="select(item)">{{ uperFirst(item.type) }}</div>
        </template>
        <template v-else>
          <el-image v-if="item.image" @click="select(item)" style="width: 7vh;" :src="require(`@/assets/render/${item.image}.png`)"></el-image>
          <div style="color:black" @click="select(item)">{{ uperFirst(item.type) }}</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
    }
  },
  computed: {
    inprint () {
      if (this.$store.state.editor.inprints && this.$store.state.editor.inprints.length > 1) {
        return this.$store.state.editor.inprints
      } else {
        return []
      }
    },
    selected () {
      return this.$store.state.editor.inprint?.type
    }
  },
  methods: {
    select (item) {
      if (this.$store.state.editor.inprint.type === item.type) return
      this.$emit('change', item)
    },
    uperFirst (str) {
      str += ''
      if (str && str.length > 1) {
        return str.replace(str[0], str[0].toUpperCase())
      } else {
        return str
      }
    }
  }
}
</script>

<style lang="css" scoped>
.container {
  display: flex;
  flex-direction: column;
}
.containerPhone {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-top: 10px;
}
.pointer {
  cursor: pointer;
}
</style>
